import { atom } from "jotai";

const OPENBRIEF_AI_TERMS_ACCEPTED = "openbrief_ai_terms_accepted";

const acceptedTerms = atom(
  JSON.parse(
    localStorage.getItem(OPENBRIEF_AI_TERMS_ACCEPTED) ?? "false"
  ) as boolean
);

export const openBriefAITermsAcceptedAtom = atom(
  (get) => get(acceptedTerms),
  (_get, set, newVal: boolean) => {
    set(acceptedTerms, newVal);
    localStorage.setItem(OPENBRIEF_AI_TERMS_ACCEPTED, JSON.stringify(newVal));
  }
);

const internalBriefWithAI = atom<boolean | null>(null);

export const isBriefWithAIAtom = atom(
  (get) => {
    const internal = get(internalBriefWithAI);

    if (internal !== null) {
      return internal;
    }

    return get(openBriefAITermsAcceptedAtom);
  },
  (_get, set, newVal: boolean) => {
    set(internalBriefWithAI, newVal);
  }
);

export const allowBriefSubmitNavigationAtom = atom(false);
